import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	subTitleNonFinal: {
		id: 'periscope.header.sub-title-non-final',
		defaultMessage: 'Your work suggestions',
		description:
			'This is the sub-title for periscope page. Periscope page is the page where users (developers) see their work suggestions. In many(not all) languages, this word is not translated, but literally called "Work suggestions" in each language format.',
	},
});
